(() => {
  const sources = {
  "fd-home-03-ab-daisy-ecom323521.webp": {
    "file": "fd-home-03-ab-daisy-ecom323521-full.webp",
    "smallWidth": 1800,
    "width": 1920,
    "height": 2400
  },
  "fd-home-04-ron31.webp": {
    "file": "fd-home-04-ron31-full.webp",
    "smallWidth": 1800,
    "width": 2992,
    "height": 2062
  },
  "fd-home-05-yosemite41.webp": {
    "file": "fd-home-05-yosemite41-full.webp",
    "smallWidth": 1800,
    "width": 2731,
    "height": 4096
  },
  "fd-home-06-sliders1.webp": {
    "file": "fd-home-06-sliders1-full.webp",
    "smallWidth": 1800,
    "width": 2992,
    "height": 1934
  },
  "fd-home-07-muir-woods23.webp": {
    "file": "fd-home-07-muir-woods23-full.webp",
    "smallWidth": 1800,
    "width": 4096,
    "height": 2701
  },
  "fd-product-01-01-ron-ocean-solo0079-master-web1.webp": {
    "file": "fd-product-01-01-ron-ocean-solo0079-master-web1-full.webp",
    "smallWidth": 1800,
    "width": 4096,
    "height": 2731
  },
  "fd-product-04-ab-daisy-ecom32411.webp": {
    "file": "fd-product-04-ab-daisy-ecom32411-full.webp",
    "smallWidth": 1800,
    "width": 1920,
    "height": 2400
  },
  "fd-product-05-ab-daisy-ecom309121.webp": {
    "file": "fd-product-05-ab-daisy-ecom309121-full.webp",
    "smallWidth": 1800,
    "width": 3277,
    "height": 4096
  },
  "fd-product-06-ab-daisy-ecom323521.webp": {
    "file": "fd-product-06-ab-daisy-ecom323521-full.webp",
    "smallWidth": 1800,
    "width": 1920,
    "height": 2400
  },
  "fd-product-07-04-malia-grass-solo1488-web-master-v21.webp": {
    "file": "fd-product-07-04-malia-grass-solo1488-web-master-v21-full.webp",
    "smallWidth": 1800,
    "width": 2731,
    "height": 4096
  },
  "fd-product-08-20260206-daisy-sfo-r01041.webp": {
    "file": "fd-product-08-20260206-daisy-sfo-r01041-full.webp",
    "smallWidth": 1800,
    "width": 4096,
    "height": 3261
  },
  "fd-product-09-image1709.webp": {
    "file": "fd-product-09-image1709-full.webp",
    "smallWidth": 1800,
    "width": 4096,
    "height": 2731
  },
  "fd-product-16-aluminum1.webp": {
    "file": "fd-product-16-aluminum1-full.webp",
    "smallWidth": 1800,
    "width": 4096,
    "height": 2031
  },
  "fd-product-18-joshua-tree2.webp": {
    "file": "fd-product-18-joshua-tree2-full.webp",
    "smallWidth": 1800,
    "width": 2560,
    "height": 3840
  },
  "fd-product-19-yosemite42.webp": {
    "file": "fd-product-19-yosemite42-full.webp",
    "smallWidth": 1800,
    "width": 2731,
    "height": 4096
  },
  "fd-product-20-sandra-desktop.webp": {
    "file": "fd-product-20-sandra-desktop-full.webp",
    "smallWidth": 1200,
    "width": 2731,
    "height": 4096
  },
  "fd-product-21-channel-islands51.webp": {
    "file": "fd-product-21-channel-islands51-full.webp",
    "smallWidth": 1800,
    "width": 3500,
    "height": 2623
  },
  "fd-product-22-muir-woods22.webp": {
    "file": "fd-product-22-muir-woods22-full.webp",
    "smallWidth": 1800,
    "width": 4096,
    "height": 2701
  },
  "fd-product-31-untitled13.webp": {
    "file": "fd-product-31-untitled13-full.webp",
    "smallWidth": 1800,
    "width": 4096,
    "height": 1554
  },
  "fd-product-33-arv-ecom31221.webp": {
    "file": "fd-product-33-arv-ecom31221-full.webp",
    "smallWidth": 1800,
    "width": 2560,
    "height": 2560
  },
  "fd-behind-01-ab-daisy-stills34031.webp": {
    "file": "fd-behind-01-ab-daisy-stills34031-full.webp",
    "smallWidth": 1800,
    "width": 3840,
    "height": 2400
  },
  "fd-behind-05-arv-ecom33161.webp": {
    "file": "fd-behind-05-arv-ecom33161-full.webp",
    "smallWidth": 1800,
    "width": 2560,
    "height": 2560
  },
  "fd-behind-06-arv-ecom31221.webp": {
    "file": "fd-behind-06-arv-ecom31221-full.webp",
    "smallWidth": 1800,
    "width": 2560,
    "height": 2560
  },
  "fd-behind-07-untitled12.webp": {
    "file": "fd-behind-07-untitled12-full.webp",
    "smallWidth": 1800,
    "width": 2160,
    "height": 3840
  },
  "fd-behind-08-ab-daisy-stills32681.webp": {
    "file": "fd-behind-08-ab-daisy-stills32681-full.webp",
    "smallWidth": 1800,
    "width": 1920,
    "height": 2400
  },
  "fd-still-joshua.webp": {
    "file": "fd-still-joshua-full.webp",
    "smallWidth": 1600,
    "width": 2560,
    "height": 3840
  },
  "fd-still-muir.webp": {
    "file": "fd-still-muir-full.webp",
    "smallWidth": 2400,
    "width": 4096,
    "height": 2701
  },
  "fd-still-yosemite.webp": {
    "file": "fd-still-yosemite-full.webp",
    "smallWidth": 1600,
    "width": 2731,
    "height": 4096
  },
  "fd-still-channel.webp": {
    "file": "fd-still-channel-full.webp",
    "smallWidth": 2400,
    "width": 3500,
    "height": 2623
  },
  "fd-still-button.webp": {
    "file": "fd-still-button-full.webp",
    "smallWidth": 2400,
    "width": 4096,
    "height": 1554
  },
  "SILVER1-mobile.webp": {
    "file": "SILVER1-full.webp",
    "smallWidth": 1200,
    "width": 2560,
    "height": 2560
  },
  "SILVER2-mobile.webp": {
    "file": "SILVER2-full.webp",
    "smallWidth": 1200,
    "width": 2560,
    "height": 2560
  },
  "SILVER3-mobile.webp": {
    "file": "SILVER3-full.webp",
    "smallWidth": 1200,
    "width": 2560,
    "height": 2560
  },
  "SILVER4-mobile.webp": {
    "file": "SILVER4-full.webp",
    "smallWidth": 1200,
    "width": 2560,
    "height": 2560
  },
  "SILVER5-mobile.webp": {
    "file": "SILVER5-full.webp",
    "smallWidth": 1200,
    "width": 2560,
    "height": 2560
  },
  "PACIFIC1-mobile.webp": {
    "file": "PACIFIC1-full.webp",
    "smallWidth": 1200,
    "width": 2560,
    "height": 2560
  },
  "PACIFIC2-mobile.webp": {
    "file": "PACIFIC2-full.webp",
    "smallWidth": 1200,
    "width": 2560,
    "height": 2560
  },
  "PACIFIC3-mobile.webp": {
    "file": "PACIFIC3-full.webp",
    "smallWidth": 1200,
    "width": 2560,
    "height": 2560
  },
  "PACIFIC4-mobile.webp": {
    "file": "PACIFIC4-full.webp",
    "smallWidth": 1200,
    "width": 2560,
    "height": 2560
  },
  "PACIFIC5-mobile.webp": {
    "file": "PACIFIC5-full.webp",
    "smallWidth": 1200,
    "width": 2560,
    "height": 2560
  },
  "KELP1-mobile.webp": {
    "file": "KELP1-full.webp",
    "smallWidth": 1200,
    "width": 2560,
    "height": 2560
  },
  "KELP2-mobile.webp": {
    "file": "KELP2-full.webp",
    "smallWidth": 1200,
    "width": 2560,
    "height": 2560
  },
  "KELP3-mobile.webp": {
    "file": "KELP3-full.webp",
    "smallWidth": 1200,
    "width": 2560,
    "height": 2560
  },
  "KELP4-mobile.webp": {
    "file": "KELP4-full.webp",
    "smallWidth": 1200,
    "width": 2560,
    "height": 2560
  },
  "KELP5-mobile.webp": {
    "file": "KELP5-full.webp",
    "smallWidth": 1200,
    "width": 2560,
    "height": 2560
  },
  "figma-ecomm-case-silver-mobile.webp": {
    "file": "desktop-case-silver-full.webp",
    "smallWidth": 1200,
    "width": 2560,
    "height": 2560
  },
  "figma-ecomm-case-pacific-mobile.webp": {
    "file": "desktop-case-pacific-full.webp",
    "smallWidth": 1200,
    "width": 2560,
    "height": 2560
  },
  "figma-ecomm-case-kelp-mobile.webp": {
    "file": "desktop-case-kelp-full.webp",
    "smallWidth": 1200,
    "width": 2560,
    "height": 2560
  },
  "fd-still-hero-optimized.webp": {
    "file": "desktop-still-hero-full.webp",
    "smallWidth": 1800,
    "width": 4096,
    "height": 2731
  },
  "fd-behind-09-muir-woods23.webp": {
    "file": "fd-home-07-muir-woods23-full.webp",
    "smallWidth": 1800,
    "width": 4096,
    "height": 2701
  },
  "fd-support-footer.webp": {
    "file": "fd-home-07-muir-woods23-full.webp",
    "smallWidth": 2400,
    "width": 4096,
    "height": 2701
  },
  "fd-faq-footer.webp": {
    "file": "fd-home-07-muir-woods23-full.webp",
    "smallWidth": 2400,
    "width": 4096,
    "height": 2701
  }
};
  const selector = '.figma-desktop-page img, .figma-desktop-footer img';
  const update = image => {
    if (!(image instanceof HTMLImageElement) || !image.matches(selector)) return;
    if (innerWidth < 990) return;
    // The gallery owns source selection and decode timing for its two transition layers.
    if (image.closest('.fdp-gallery-media')) return;
    const raw = image.getAttribute('src') || image.dataset.src;
    if (!raw) return;
    const url = new URL(raw, location.href);
    const name = decodeURIComponent(url.pathname.split('/').pop());
    const source = sources[name];
    if (!source) {
      if (image.dataset.desktopResolution) {
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        delete image.dataset.desktopResolution;
      }
      return;
    }
    const bounds = image.getBoundingClientRect();
    if (!bounds.width) return;
    const style = getComputedStyle(image);
    const width = style.objectFit === 'cover'
      ? Math.max(bounds.width, bounds.height * source.width / source.height)
      : bounds.width;
    const full = new URL(url);
    full.pathname = full.pathname.slice(0, full.pathname.lastIndexOf('/') + 1) + source.file;
    full.search = '';
    image.sizes = Math.ceil(width) + 'px';
    const srcset = url.href + ' ' + source.smallWidth + 'w, ' + full.href + ' ' + source.width + 'w';
    if (image.srcset !== srcset) image.srcset = srcset;
    image.dataset.desktopResolution = source.file;
  };
  const scan = () => document.querySelectorAll(selector).forEach(update);
  const observer = new MutationObserver(records => {
    const changed = new Set();
    for (const record of records) {
      if (record.type === 'attributes') changed.add(record.target);
      else record.addedNodes.forEach(node => {
        if (node.nodeType !== 1) return;
        if (node.matches('img')) changed.add(node);
        node.querySelectorAll('img').forEach(image => changed.add(image));
      });
    }
    changed.forEach(update);
  });
  observer.observe(document.documentElement, {
    subtree: true, childList: true, attributes: true,
    attributeFilter: ['src', 'data-src']
  });
  let frame;
  const resize = () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(scan); };
  addEventListener('resize', resize, { passive: true });
  addEventListener('load', resize, { once: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once:true });
  else scan();
})();
